<ng-container *ngIf="event">
  <div class="title" fxLayout="row" fxLayoutAlign="space-between end">
    <h1>{{'イベント情報' | translate}}</h1>

    <div class="basic-button" fxLayoutGap="10px">
      <button mat-raised-button color="primary" (click)="setEvent()" [disabled]="eventFormGroup.invalid || event.entrances.length === 0 || event.exits.length === 0 || !isValidSplatsQr()">
        <mat-icon>add</mat-icon>
        <span>{{ (isAdded ? '追加' : '更新') | translate }}</span>
      </button>
    </div>
  </div>


  <div fxLayout="column" fxLayoutAlign="center center">
    <form class="form" [formGroup]="eventFormGroup" style="width: 85%;">

      <div class="supplement" style="text-align: left; padding-bottom: 30px;">▼{{'イベント情報の追加と更新' | translate}}<br>
        &nbsp;&nbsp;&nbsp;{{'※初回は無条件でイベント情報が追加されます。' | translate}}<br>
        &nbsp;&nbsp;&nbsp;{{'※2回目以降は施設、開催期間、募集期間のどれも変更しない場合は既存のイベント情報が更新されます。施設、開催期間、募集期間のどれかを変更した場合は新規にイベント情報が登録されますが、過去に登録したイベント情報と開催期間か募集期間が重複する場合は登録できません。'
        | translate}}<br>
        &nbsp;&nbsp;&nbsp;{{'※最後に追加(更新)したイベント情報が有効となります。(過去に登録したイベント情報も保存はされています)' | translate}}
      </div>

      <div fxLayout="row" fxLayoutGap="20px">
        <!-- 画面右部 -->
        <div fxFlex="50%" fxLayout="column" fxLayoutGap="20px">

          <!-- 施設 -->
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'施設' | translate}}</mat-label>
            <mat-select placeholder="{{'施設' | translate}}" formControlName="facilityId">
              <mat-option [value]=""></mat-option>
              <mat-option *ngFor="let facility of (facilities | async)" [value]="facility.facility_id">
                {{ facility.facility_names | multiName:projectLanguages:projectBaseLang }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="facilityIdControl.invalid">{{ getErrorMessageToFacilityId() }}</mat-error>
          </mat-form-field>

          <!-- 名称 -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="names"
              value="{{ event!.names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="namesControl.invalid">{{ getErrorMessageToNames() }}</mat-error>
          </mat-form-field>

          <!-- 詳細 -->
          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="descriptions" rows="3"
              value="{{ event!.descriptions | multiDesc:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="descriptionsControl.invalid">{{ getErrorMessageToDescriptions() }}</mat-error>
          </mat-form-field>

          <!-- 画像ファイル -->
          <div fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'画像ファイル' | translate}}（ {{ !!event!.files ? event!.files.length:0 }} {{'件' | translate}}）</span>
            <button mat-stroked-button (click)="openSelectFilesDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル追加' | translate}}</span>
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th style="width: 100px;">{{'言語' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropFile($event)">
              <tr *ngFor="let file of eventFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                <td><img [src]="file.download_url" height="40px" width="auto"></td>
                <td>{{ file.file_name }}</td>
                <td>
                  <mat-select id="lang" [value]="file.lang_code" (selectionChange)="changeFileLang(i, $event)">
                    <ng-container *ngFor="let language of projectLanguages">
                      <mat-option [value]="language.lang_code">
                        {{ projectBaseLang == 'en' ? (projectLanguages[i].lang_name_en ? projectLanguages[i].lang_name_en : (projectLanguages[i].lang_name | translate)):  projectLanguages[i].lang_name }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="supplement">▼{{'イベントの開催期間と来場者の募集期間を設定します。' | translate}}</div>
          <!-- 開催期間 -->
          <div class="inputform30" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label>{{'開催期間：開始日 - 終了日' | translate}}</mat-label>
              <mat-date-range-input [rangePicker]="pickerOpen">
                <input matStartDate formControlName="openStartDate" placeholder="{{'開始日' | translate}}" readonly>
                <input matEndDate formControlName="openEndDate" placeholder="{{'終了日' | translate}}" readonly>
              </mat-date-range-input>
              <button mat-button matSuffix aria-label="Clear" (click)="clearOpenDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="pickerOpen"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerOpen></mat-date-range-picker>
              <mat-error *ngIf="openStartDateControl.invalid || openEndDateControl.invalid">{{
                getErrorMessageToOpenDate() }}</mat-error>
            </mat-form-field>

            <!-- 募集期間 -->
            <mat-form-field fxFlex="50%">
              <mat-label>{{'募集期間：開始日 - 終了日' | translate}}</mat-label>
              <mat-date-range-input [rangePicker]="pickerEntry">
                <input matStartDate formControlName="entryStartDate" placeholder="{{'開始日' | translate}}" readonly>
                <input matEndDate formControlName="entryEndDate" placeholder="{{'終了日' | translate}}" readonly>
              </mat-date-range-input>
              <button mat-button matSuffix aria-label="Clear" (click)="clearEntryDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="pickerEntry"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerEntry></mat-date-range-picker>
              <mat-error *ngIf="entryStartDateControl.invalid || entryEndDateControl.invalid">{{
                getErrorMessageToEntryDate() }}</mat-error>
            </mat-form-field>
          </div>

          <div class="inputform30" fxLayout="column" fxLayoutGap="20px">
            <div class="supplement">▼{{'エントリー完了時に送信するメールのタイトルや文面を設定します。' | translate}}</div>
            <!-- エントリー完了時：メール設定 -->
            <mat-form-field>
              <mat-label floatLabel="always">{{'メールタイトル' | translate}}</mat-label>
              <input matInput placeholder="{{'メールタイトル' | translate}} *"
                value="{{ event!.entry_mail_titles | multiSendMailTitle:projectLanguages:projectBaseLang }}" readonly>
              <button matSuffix mat-stroked-button color="primary" (click)="openEntryMailMessageTitleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="entryMailTitlesControl.invalid">{{ getErrorMessageToEntryMailTitles() }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label floatLabel="always">{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（文頭）*　※メール本文の文頭に配置します。' | translate}}" rows="3"
                value="{{ event!.entry_mail_messages1 | multiSendMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary" (click)="openEntryMailMessageHeaderDialog()">
                <mat-icon>edit</mat-icon>
              </button>
              <mat-error *ngIf="entryMailMessages1Control.invalid">{{ getErrorMessageToEntryMailMessages1()
                }}</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'メール本文（文中）　※メール本文の文頭、エントリー情報の下に配置します（例：留意事項など）。' |
                translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（文中）　※メール本文の文頭、エントリー情報の下に配置します（例：留意事項など）。' | translate}}" rows="3"
                value="{{ event!.entry_mail_messages2 | multiSendMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary" (click)="openEntryMessageMiddleDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}</mat-label>
              <textarea matInput placeholder="{{'メール本文（末尾）　※メール本文の末尾に配置します（例：問い合わせ先など）。' | translate}}" rows="3"
                value="{{ event!.entry_mail_messages3 | multiSendMailMessage:projectLanguages:projectBaseLang }}"
                readonly></textarea>
              <button matSuffix mat-stroked-button color="primary" (click)="openEntryMessageFooterDialog()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>

        <!-- 画面左部 -->
        <div fxFlex="50%" fxLayout="column" fxLayoutGap="20px">

          <!-- 入場口 -->
          <div fxLayout="row" fxLayoutAlign="space-between end">
            <div class="supplement">▼{{'入場口（１つ以上）を設定します。' | translate}}</div>
            <button mat-stroked-button (click)="appendEntrance()">
              <mat-icon>add</mat-icon>
              <span>{{'入場口追加' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th width="30px">No.</th>
                <th>{{'名前' | translate}}</th>
                <th width="70px">{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropEntrance($event)">
              <tr *ngFor="let entrance of event!.entrances!; let i = index" cdkDrag cdkDragLockAxis="y">
                <td width="30px">
                  {{ i + 1 }}
                </td>
                <td>
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput type="text" [value]="entrance.name" (change)="changeEntranceName($event, i)">
                  </mat-form-field>
                </td>
                <td width="70px" style="overflow: auto;">
                  <button mat-stroked-button color="warn" (click)="deleteEntrance(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- 退場口 -->
          <div fxLayout="row" fxLayoutAlign="space-between end">
            <div class="supplement">▼{{'退場口（１つ以上）を設定します。' | translate}}</div>
            <button mat-stroked-button (click)="appendExit()">
              <mat-icon>add</mat-icon>
              <span>{{'退場口追加' | translate}}</span>
            </button>
          </div>
          <table>
            <thead>
              <tr>
                <th width="30px">No.</th>
                <th>{{'名前' | translate}}</th>
                <th width="70px">{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropExit($event)">
              <tr *ngFor="let exit of event!.exits!; let i = index" cdkDrag cdkDragLockAxis="y">
                <td width="30px">
                  {{ i + 1 }}
                </td>
                <td>
                  <mat-form-field fxFlexFill floatLabel="always">
                    <input matInput type="text" [value]="exit.name" (change)="changeExitName($event, i)">
                  </mat-form-field>
                </td>
                <td width="70px" style="overflow: auto;">
                  <button mat-stroked-button color="warn" (click)="deleteExit(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- フロア・表示グループ -->
          <div fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'フロア・表示グループリスト' | translate}}（ {{ !!event!.floor_ids ? event!.floor_ids.length:0 }} {{'件' |
              translate}}）</span>
            <button mat-stroked-button (click)="openSelectFloorsDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'フロア・表示グループリスト追加' | translate}}</span>
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>{{'説明' | translate}}</th>
                <th>{{'建物・カテゴリ' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropFloor($event)">
              <tr *ngFor="let floor of floors" cdkDrag cdkDragLockAxis="y">
                <td>{{ floor.floor_id }}</td>
                <td>{{ floor.floor_explain }}</td>
                <td>
                  <span *ngFor="let hall of (floor.hall_id | docsByCond:hallsCollectionName:'hall_id' | async)">
                    {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }}
                  </span>
                </td>
                <td>{{ floor.floor_names | multiName:projectLanguages:projectBaseLang }}</td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteFloor(floor.id!)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- 設問（基本項目） -->
          <div class="supplement">▼{{'エントリー時にユーザーに回答してもらう項目を設定します。' | translate}}</div>
          <mat-label class="inputform10">{{'設問（基本項目：チェックありで表示）' | translate}}</mat-label>
          <div fxLayout="raw wrap" fxLayoutGap="20px">
            <mat-checkbox formControlName="isVisibledCampanyName" color="primary">{{'会社名' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledDepartment" color="primary">{{'部署' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledJobTitle" color="primary">{{'役職' | translate}}</mat-checkbox>
            <ng-container *ngIf="projectBaseLang === 'ja'">
              <mat-checkbox formControlName="isVisibledSurnameChinese" color="primary">{{'姓（漢字）' | translate}}</mat-checkbox>
              <mat-checkbox formControlName="isVisibledNameChinese" color="primary">{{'名（漢字）' | translate}}</mat-checkbox>
            </ng-container>
            <mat-checkbox formControlName="isVisibledFamilyName" color="primary">{{'姓（カナ）' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledFirstName" color="primary">{{'名（カナ）' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledGender" color="primary">{{'性別' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledBirthday" color="primary">{{'生年月日' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledAddress" color="primary">{{'住所' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledMobilePhoneNumber" color="primary">{{'携帯電話番号' |
              translate}}</mat-checkbox>
          </div>

          <!-- 設問（カスタム項目） -->
          <div class="supplement">▼{{'基本項目以外に回答してもらう項目（設問で登録済のもの）を設定します。' | translate}}</div>
          <div class="inputform20 floor-list">
            <div class="floor-list-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'設問（カスタム項目：' | translate}} {{ !!event.questions ? event.questions.length:0 }} {{'件' |
                translate}}）</span>
              <button mat-stroked-button (click)="openSelectQuestionsDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'設問追加' | translate}}</span>
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'設問名' | translate}}</th>
                  <th>{{'設問タイプ' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropQuestion($event)">
                <tr *ngFor="let question of event?.questions" cdkDrag cdkDragLockAxis="y">
                  <td>{{ question.question_id }}</td>
                  <td>{{ question.question_names | multiName:projectLanguages:projectBaseLang }}</td>
                  <td>{{ question.question_type }}</td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteQuestion(question.question_id!)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


          <!-- QRコードに出力する予約設問(基本項目) -->
          <div class="supplement">{{'▼入退場用QRコードと共に出力する項目を設定します。(最大5つ)' | translate}}</div>
          <mat-label class="inputform10">{{'設問（基本項目：チェックありで出力）' | translate}}</mat-label>
          <div fxLayout="raw wrap" fxLayoutGap="20px">
            <mat-checkbox formControlName="isVisibledQrCompanyName" color="primary">{{'会社名' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledQrDepartment" color="primary">{{'部署' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledQrJobTitle" color="primary">{{'役職' | translate}}</mat-checkbox>
            <ng-container *ngIf="projectBaseLang === 'ja'">
              <mat-checkbox formControlName="isVisibledQrSurnameNameChinese" color="primary">{{'姓名（漢字）' | translate}}</mat-checkbox>
            </ng-container>
            <mat-checkbox formControlName="isVisibledQrFamilyFirstName" color="primary">{{'姓名（カナ）' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledQrGender" color="primary">{{'性別' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledQrBirthday" color="primary">{{'生年月日' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledQrAddress" color="primary">{{'住所' | translate}}</mat-checkbox>
            <mat-checkbox formControlName="isVisibledQrMobilePhoneNumber" color="primary">{{'携帯電話番号' | translate}}</mat-checkbox>
          </div>

        </div>

      </div>
    </form>
  </div>
</ng-container>